import { CtaBanner, PageHeader } from "@/components/site/SiteLayout";

const ABOUT_IMG = "https://static.prod-images.emergentagent.com/jobs/aa99b69d-72c0-48f6-8f74-1387bc38d4ab/images/4150ff42e471c002155c973fbfaeaac59234eaf6982c28c3eef1c23746307fa0.jpeg";

const PRINCIPLES = [
  ["Speed is a feature", "Fast sites rank higher, convert better and cost less to run. We measure it on every release."],
  ["Plain-English pricing", "Fixed quotes, clear scope and no surprise invoices. You always know what you're paying for."],
  ["You own everything", "Code, domains, hosting accounts and content stay in your name. No lock-in."],
  ["Operator mindset", "We run our own sites for profit, so we think in traffic, leads and revenue, not just pixels."],
];

const STACK = ["React", "Next.js", "FastAPI", "Python", "Node.js", "Tailwind CSS", "MongoDB", "PostgreSQL", "Vercel", "Cloudflare", "AWS", "Stripe"];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader eyebrow="// about" title="A small studio that builds like an owner." testId="about-title">
        Beall Digital Group is a web development agency led by Brent Beall. We build for clients, and we build for ourselves.
      </PageHeader>
      <section className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-16 sm:px-6 md:py-24 lg:grid-cols-2 lg:px-12">
        <div className="space-y-5 text-slate-400">
          <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">Our story</h2>
          <p>Beall Digital Group started the way most good web businesses do: building sites that had to pay for themselves. Running our own content and tool sites taught us what actually moves the needle: speed, search visibility, clear offers and relentless iteration.</p>
          <p>Today we bring that same operator playbook to clients. Whether you need a sharp marketing site, an online store or a custom web app, you work directly with the people writing the code, from first call to launch and beyond.</p>
          <p>Every project ships with clean, documented code, modern hosting and a plan to keep improving after go-live.</p>
        </div>
        <div className="overflow-hidden rounded-2xl border border-white/10">
          <img src={ABOUT_IMG} alt="Developer workstation with code on screen at night" className="aspect-[3/2] w-full object-cover" />
        </div>
      </section>
      <section className="border-y border-white/5 bg-[#0A0D15]">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-12">
          <p className="mb-3 font-mono-tech text-xs uppercase tracking-[0.25em] text-cyan-400">// principles</p>
          <h2 className="mb-12 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">How we work.</h2>
          <div className="grid gap-6 md:grid-cols-2">
            {PRINCIPLES.map(([t, d], i) => (
              <div key={t} data-testid={`about-principle-${i}`} className="card-tech rounded-2xl p-6 sm:p-8">
                <span className="font-mono-tech text-xs text-cyan-400">0{i + 1}</span>
                <h3 className="mt-2 text-xl font-semibold text-white">{t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-12">
        <p className="mb-3 font-mono-tech text-xs uppercase tracking-[0.25em] text-cyan-400">// stack</p>
        <h2 className="mb-8 text-2xl font-bold tracking-tight text-white sm:text-3xl">Tools we trust.</h2>
        <div className="flex flex-wrap gap-3">
          {STACK.map((s) => (
            <span key={s} className="rounded-full border border-white/10 bg-white/[0.02] px-4 py-2 font-mono-tech text-xs text-slate-300 transition-colors duration-200 hover:border-cyan-400/50 hover:text-cyan-200">
              {s}
            </span>
          ))}
        </div>
      </section>
      <CtaBanner />
    </div>
  );
}
